import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'

const PaymentCardUI = ({context, paymentCard, onCancel}) =>
  <CardUI context={context}>
    {
      paymentCard &&
      <div onClick={onCancel}>
        <div>{paymentCard.description}</div>
      </div>
    }
  </CardUI>

export default PaymentCardUI
